export default {
  init: function () {
    /* Anchor links */
    const scrollAnchors = Array.from(document.querySelectorAll("a[href^=\"#\"]"))
    const scrollAnchorsNav = Array.from(document.querySelectorAll(".to-home-page"))

    const scrollToAnchor = (e, targetHref) => {
      let targetEl = document.querySelector(targetHref)

      if (!!targetEl) {
        e.preventDefault()

        let box = targetEl.getBoundingClientRect()
        window.scrollTo({ top: box.top - 80 + pageYOffset, left: box.left + pageYOffset, behavior: "smooth" })
      }
    }

    if (scrollAnchors.length > 0) {
      scrollAnchors.forEach(scrollAnchor => {
        let targetHref = scrollAnchor.getAttribute("href")

        if (targetHref === "#") return

        scrollAnchor.addEventListener("click", e => scrollToAnchor(e, targetHref));
      });
    }

    if (scrollAnchorsNav.length > 0) {
      scrollAnchorsNav.forEach(scrollAnchorNav => {
        let targetHref = scrollAnchorNav.querySelector("a").setAttribute("href", `/${scrollAnchorNav.querySelector("a").getAttribute("href")}`)

        if (targetHref === "#") return

        scrollAnchorNav.addEventListener("click", e => scrollToAnchor(e, targetHref));
      })
    }
  },
}